const mapping: Record<
  string,
  (lambdaParameter: string, value: any, otherValues: any) => string | null
> = {
  transactionStatus: (lambdaParameter, value) =>
    `${lambdaParameter}.TransactionStatus.Equals(AutomatCore.Models.Log.LogTransaction.Status.${value})`,
  transactionType: (lambdaParameter, value) =>
    `${lambdaParameter}.TransactionType.Equals(AutomatCore.Enums.TransactionType.${value})`,
  paymentType: (lambdaParameter, value) =>
    `${lambdaParameter}.PaymentType.Equals(AutomatCore.Enums.PaymentType.${value})`,
}

const filterMapper = (key: string) =>
  mapping[key] as (
    lambdaParameter: string,
    value: any,
    otherValues: any,
  ) => string

export default filterMapper
